import { ColorLabelEnum, hexColor } from '@utils/map/map.constants';
import { FillLayerSpecification, LineLayerSpecification } from 'mapbox-gl';

import { FeatureTypeEnum, LayerNameEnum, SourceNameEnum } from '@/types/map.types';

export const neutralSectorStripes: FillLayerSpecification = {
  id: LayerNameEnum.NEUTRAL_SECTOR_STRIPES,
  type: 'fill',
  source: SourceNameEnum.NEUTRAL_SECTORS,
  filter: ['==', 'featureType', FeatureTypeEnum.NEUTRAL_SECTOR],
  paint: {
    'fill-pattern': 'jammingTile_512x512',
    'fill-opacity': ['case', ['==', ['get', 'isJamming'], true], 0.6, 0],
  },
};

export const neutralSectorFill: FillLayerSpecification = {
  id: LayerNameEnum.NEUTRAL_SECTOR_FILLS,
  type: 'fill',
  source: SourceNameEnum.NEUTRAL_SECTORS,
  filter: ['==', 'featureType', FeatureTypeEnum.NEUTRAL_SECTOR],
  paint: {
    'fill-color': ['get', 'color'],
    'fill-opacity': ['case', ['==', ['get', 'isJamming'], false], 0.4, 0],
  },
};

export const neutralSectorOutlines: LineLayerSpecification = {
  id: LayerNameEnum.NEUTRAL_SECTOR_OUTLINES,
  type: 'line',
  source: SourceNameEnum.NEUTRAL_SECTORS,
  filter: ['==', 'featureType', FeatureTypeEnum.NEUTRAL_SECTOR],
  paint: {
    'line-color': hexColor[ColorLabelEnum.BLACK],
    'line-width': ['case', ['any', ['==', ['get', 'isJamming'], true], ['==', ['get', 'isSelected'], true]], 3, 1],
    'line-opacity': ['case', ['any', ['==', ['get', 'isJamming'], true], ['==', ['get', 'isSelected'], true]], 1, 0.7],
  },
};
